"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _core = require("@emotion/core");

var _slateReact = require("slate-react");

var _slatePlainSerializer = _interopRequireDefault(require("slate-plain-serializer"));

var _isHotkey = _interopRequireDefault(require("is-hotkey"));

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _serializers = require("../serializers");

var _styles = require("../styles");

var _Toolbar = _interopRequireDefault(require("./Toolbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n                  ", "\n                "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

const styleStrings = {
  slateRaw: "\n    position: relative;\n    overflow: hidden;\n    overflow-x: auto;\n    min-height: ".concat(_netlifyCmsUiDefault.lengths.richTextEditorMinHeight, ";\n    font-family: ").concat(_netlifyCmsUiDefault.fonts.mono, ";\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-top: 0;\n    margin-top: -").concat(_styles.editorStyleVars.stickyDistanceBottom, ";\n  ")
};
const RawEditorContainer = (0, _styledBase.default)("div", {
  target: "er7tv020",
  label: "RawEditorContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "79elbk",
  styles: "position:relative;"
} : {
  name: "79elbk",
  styles: "position:relative;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

class RawEditor extends _react.default.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleCopy", (event, editor) => {
      const {
        getAsset,
        resolveWidget
      } = this.props;

      const markdown = _slatePlainSerializer.default.serialize(editor.value);

      const html = (0, _serializers.markdownToHtml)(markdown, {
        getAsset,
        resolveWidget
      });
      (0, _slateReact.setEventTransfer)(event, 'text', markdown);
      (0, _slateReact.setEventTransfer)(event, 'html', html);
      event.preventDefault();
    });

    _defineProperty(this, "handleCut", (event, editor, next) => {
      this.handleCopy(event, editor, next);
      editor.delete();
    });

    _defineProperty(this, "handlePaste", (event, editor, next) => {
      const data = event.clipboardData;

      if ((0, _isHotkey.default)('shift', event)) {
        return next();
      }

      const value = _slatePlainSerializer.default.deserialize(data.getData('text/plain'));

      return editor.insertFragment(value.document);
    });

    _defineProperty(this, "handleChange", editor => {
      if (!this.state.value.document.equals(editor.value.document)) {
        this.handleDocumentChange(editor);
      }

      this.setState({
        value: editor.value
      });
    });

    _defineProperty(this, "handleDocumentChange", (0, _debounce2.default)(editor => {
      const value = _slatePlainSerializer.default.serialize(editor.value);

      this.props.onChange(value);
    }, 150));

    _defineProperty(this, "handleToggleMode", () => {
      this.props.onMode('visual');
    });

    _defineProperty(this, "processRef", ref => {
      this.editor = ref;
    });

    this.state = {
      value: _slatePlainSerializer.default.deserialize(this.props.value || '')
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !this.state.value.equals(nextState.value);
  }

  componentDidMount() {
    if (this.props.pendingFocus) {
      this.editor.focus();
      this.props.pendingFocus();
    }
  }

  render() {
    const {
      className,
      field
    } = this.props;
    return (0, _core.jsx)(RawEditorContainer, null, (0, _core.jsx)(_styles.EditorControlBar, null, (0, _core.jsx)(_Toolbar.default, {
      onToggleMode: this.handleToggleMode,
      buttons: field.get('buttons'),
      disabled: true,
      rawMode: true
    })), (0, _core.jsx)(_core.ClassNames, null, (_ref) => {
      let {
        css,
        cx
      } = _ref;
      return (0, _core.jsx)(_slateReact.Editor, {
        className: cx(className, css(_templateObject(), styleStrings.slateRaw)),
        value: this.state.value,
        onChange: this.handleChange,
        onPaste: this.handlePaste,
        onCut: this.handleCut,
        onCopy: this.handleCopy,
        ref: this.processRef
      });
    }));
  }

}

exports.default = RawEditor;
RawEditor.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  onMode: _propTypes.default.func.isRequired,
  className: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  field: _reactImmutableProptypes.default.map.isRequired
};